(function () {
  'use strict';
  const links = Array.from(document.querySelectorAll('[data-credit-checkout]'));
  if (!links.length) return;

  function destination(link) {
    const url = new URL(link.getAttribute('href'), location.origin);
    if (url.origin !== location.origin || !/\/cart\/[1-9]\d*:1$/.test(url.pathname)) {
      throw new Error('This plan is currently unavailable. Please refresh and try again.');
    }
    // Prefill the verified platform email; never use a submitted customer ID as proof of ownership.
    const email = window.TAHAuth?.customer?.email;
    if (email) url.searchParams.set('checkout[email]', email);
    return url.pathname + url.search;
  }

  function reportError(message) {
    const toast = document.querySelector('#tokenly-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), 3500);
  }

  links.forEach(link => {
    link.addEventListener('click', async event => {
      if (event.defaultPrevented) return;
      // Keep standard new-tab navigation, using the current account email when available.
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) {
        try { link.setAttribute('href', destination(link)); }
        catch (error) { event.preventDefault(); reportError(error.message); }
        return;
      }
      event.preventDefault();
      if (link.dataset.checkoutBusy === 'true') return;
      link.dataset.checkoutBusy = 'true';
      link.setAttribute('aria-busy', 'true');
      try {
        // Auth configuration loads asynchronously, so wait even when enabled is initially false.
        if (window.TAHAuth?.ready) await window.TAHAuth.ready;
        location.assign(destination(link));
      } catch (error) {
        reportError(error.message || 'Checkout could not be opened. Please try again.');
      } finally {
        delete link.dataset.checkoutBusy;
        link.removeAttribute('aria-busy');
      }
    });
  });
})();
